import { Box } from "@mui/material";

import { CALIBRATE_COLORS, CALIBRATE_RADIUS_MD } from "components/hoc/Theme";
import {
  SHELL_FOOTER_PX,
  SHELL_MAIN_CHROME_PADDING_PX,
  SHELL_TOP_BAR_PX,
} from "config";

type ShellMainContentPanelProps = {
  children?: React.ReactNode;
};

const LANDING_MAIN_MIN_HEIGHT_CSS = `calc(100vh - ${SHELL_TOP_BAR_PX}px - ${SHELL_FOOTER_PX}px)`;

export default function ShellMainContentPanel({
  children,
}: ShellMainContentPanelProps) {
  const gutter = `${SHELL_MAIN_CHROME_PADDING_PX}px`;

  return (
    <Box
      sx={{
        flex: "1 1 auto",
        minWidth: 0,
        minHeight: LANDING_MAIN_MIN_HEIGHT_CSS,
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        bgcolor: CALIBRATE_COLORS.chromeBackground,
        p: gutter,
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={(theme) => ({
          bgcolor: "background.paper",
          borderRadius: `${CALIBRATE_RADIUS_MD}px`,
          boxShadow: theme.shadows[2],
          width: "100%",
          maxWidth: { xs: "100%", sm: 720, md: 1065, lg: 1200 },
          flex: 1,
          minHeight: 0,
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          boxSizing: "border-box",
          overflow: "visible",
        })}
      >
        {children}
      </Box>
    </Box>
  );
}
